module.exports = __webpack_public_path__ + "static/img/helloworldQs.68de2a9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pblCourse/helloworldQs.gif
// module id = MMbi
// module chunks = 4